import React from "react";
import Header from "../../../../Components/Header";
import { Helmet } from "react-helmet";
import MainList from "./MainList";

function JournalEntry() {
  return (
    <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
      <Helmet>
        <title>Cost Center Allocation List</title>
      </Helmet>
      <Header />
      <div
        className="container-fluid maindiv d-flex flex-column "
        style={{ flexGrow: "1" }}
      >
        <MainList />
      </div>
    </div>
  );
}

export default JournalEntry;